var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDeviceMobile = function SvgDeviceMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 27 27",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.166 5.556a1.39 1.39 0 0 0-1.389-1.39H8.89a1.39 1.39 0 0 0-1.39 1.39V21.11a1.39 1.39 0 0 0 1.39 1.39h8.889a1.39 1.39 0 0 0 1.388-1.39zm1.667 15.555a3.055 3.055 0 0 1-3.055 3.056h-8.89a3.055 3.055 0 0 1-3.055-3.056V5.556A3.055 3.055 0 0 1 8.889 2.5h8.889a3.055 3.055 0 0 1 3.055 3.056z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.444 3.611a.833.833 0 1 1 0 1.667h-2.222a.833.833 0 0 1 0-1.667zM12.5 18.9v-.011a.833.833 0 0 1 1.666 0v.01a.833.833 0 1 1-1.667 0"
  })));
};
export default SvgDeviceMobile;